/**
 * 封装axios
 */

import axios from 'axios';
import { stringify } from 'qs';
import { Toast } from '@nutui/nutui';
import { httpMethod, RESPONSE_NO_AUTH } from '@/constants/http';
import { siteApi } from '@/apis';
import store from '../store';

const axiosInstance = axios.create({
	method: httpMethod.post,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
	},
	baseURL: process.env.VUE_APP_BASE_URL,
	transformRequest: [
		(data) => {
			data && (data._t = Date.now());
			return data ? stringify(data) : data;
		},
	],
	timeout: 30000, //TODO: 需要一定的等待时间
});

axiosInstance.interceptors.request.use(
	(config) => {
		const loading = config.loading !== undefined ? config.loading : true;
		const token = store.state.user.token;
		const userId = store.state.user.userId;
		if (loading) {
			if (typeof loading === 'boolean') {
				Toast.loading('加载中', {
					cover: true,
				});
			} else {
				Toast.loading(loading.text, {
					cover: true,
					...loading,
				});
			}
		}
		if (token) config.headers.Authorization = `Bearer ${token}`;
		if (userId) config.headers.Userid = userId;
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

axiosInstance.interceptors.response.use(
	(response) => {
		// 配置全局loading
		const config = response.config;
		const { ret, msg, data } = response.data;
		if (config.loading || config.loading === undefined) {
			Toast.hide();
		}
		if (ret === 0) {
			return config.returnFull ? response.data : data; // 如需返回所有数据结构， 配置returnFull
		} else {
			Toast.hide();
			Toast.fail(msg);
			if (response?.config.url !== '/site/ajaxerror') {
				siteApi.ajax_error({
					result: msg,
					path: response.config.url,
					request: response.config.data,
				});
			}
			return Promise.reject(Error(msg));
		}
	},
	(error) => {
		Toast.hide();
		if (error?.config.url !== '/site/ajaxerror') {
			siteApi.ajax_error({
				result:
					error.response?.data?.msg ||
					error.response?.msg ||
					error.message,
				path: error.config.url,
				request: error.config.data,
			});
		}
		if (error?.response?.status === RESPONSE_NO_AUTH) {
			store.dispatch('user/logout');
		} else {
			Toast.fail(
				error.message.includes('timeout')
					? '接口请求超时'
					: error.message
			);
		}
		return Promise.reject(error.message);
	}
);

export default axiosInstance;
